import React from "react";
import moment from "moment-jalaali";
import "moment/locale/fa";

const utils = () => {
  return null;
};

// time convertor
export const timeConverter = (
  timestamp: string,
  type?: "date" | "time"
): string => {
  moment.loadPersian();

  const date = moment(timestamp).locale("fa").format("jD jMMMM jYYYY");

  const time = moment(timestamp).locale("fa").format("HH:mm");

  const dateAndTime = moment(timestamp)
    .locale("fa")
    .format("jD jMMMM jYYYY [ساعت] HH:mm");

  if (type === "date") return date;
  if (type === "time") return time;
  return dateAndTime;
};

// create new id
export const idGenerator = (): number => {
  const timestamp: number = new Date().getTime();
  const shortenedTimestamp: number = timestamp % 100000;
  const randomNumber: number = Math.round(Math.random() * 1000000);
  const newID: number = shortenedTimestamp + randomNumber;

  return newID;
};

export default utils;
